/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';
import {ToastrService} from 'ngx-toastr';

import {handleCopyModalResult} from '../common/util/handle-copy-modal-result';
import {AngularModalService} from '../common/modal/angular-modal.service';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {LineItemTemplateCopyModalComponent} from './line-item-template-copy-modal.component';
import template from './line-item-template-context-actions.component.html';
import {LineItemModel} from './line-item-api.service';

@Component({
  standalone: false,
  selector: 'adn-line-item-template-context-actions',
  template
})
export class LineItemTemplateContextActionsComponent {
  @Input() state: SignalAdminResourcePageState<LineItemModel>;

  constructor(
    private readonly $state: StateService,
    private readonly toastr: ToastrService,
    private readonly angularModalService: AngularModalService
  ) {
  }

  createLineItem(): void {
    if (this.state.readOnly()) {
      return;
    }
    this.openCopyModal(true);
  }

  copy(): void {
    if (this.state.readOnly()) {
      return;
    }
    this.openCopyModal(false);
  }

  private openCopyModal(copyToLineItem: boolean): void {
    const modalRef = this.angularModalService.show(LineItemTemplateCopyModalComponent, {
      initialState: {
        model: this.state.model(),
        copyToLineItem,
        fromLineItemList: false
      },
      class: 'modal-lg'
    });
    (modalRef.content as LineItemTemplateCopyModalComponent).onCopied.subscribe((result) => {
      handleCopyModalResult(() => {
        const url = copyToLineItem ? 'app.adv.line-items.line-item' : 'app.adv.line-item-templates.line-item-template';
        const text = copyToLineItem ? 'line item' : 'line item template';
        if (result.destination) {
          this.$state.go(url, {id: result.newId}, {inherit: false});
        } else {
          this.toastr.success('A copy of this ' + text + ' was successfully created.', text.toUpperCase() + ' Copied');
        }
      });
    });
  }
}
